import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import BreadCrumb from '../../components/BreadCrumb';
import style from './index.scss';
import uniq from 'lodash/uniq';

import {
  Col,
  Row,
  Button,
  Space,
  Input,
  DatePicker,
  InputNumber,
  Spin
} from 'antd';
import { trim } from 'lodash';
import moment from 'moment';
import get from 'lodash/get';
import ResultsComponent from './results.jsx';

const { Search } = Input;

const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY'];

const Sandbox = (props) => {
  const { searchResults, isAppLoading } = props;
  const fieldValueObjWithDefaultValues = {
    nameWeightage: 60,
    nationalityWeightage: 5,
    dateOfBirthWeightage: 5,
    aliasWeightage: 15,
    countryOfBirthWeightage: 5,
    addressWeightage: 10
  };
  const { apiActions } = props;
  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const [fieldValueObj, setFieldValueObj] = useState(
    fieldValueObjWithDefaultValues
  );
  const [errors, setErrors] = useState({});
  const [profileMatchingArray, setProfileMatchingArray] = useState(['name']);
  const [searchFormPayload, setSearchFormPayload] = useState({});

  useEffect(() => {
    apiActions.resetAMLSCommonSandboxUIResults();
  }, []);

  //Disabling the calendar to select future dates
  const disabledDate = (current) => current && current > moment().endOf('day');

  const onSearch = () => {
    const residentialAddress = [
      'addressLine1',
      'addressLine2',
      'country',
      'city',
      'postCode'
    ];
    let profileArray = ['name'];
    let rescoreQueryMultiplier =
      (fieldValueObj['name'] ? fieldValueObj['nameWeightage'] : 0) +
      (fieldValueObj['nationality']
        ? fieldValueObj['nationalityWeightage']
        : 0) +
      (fieldValueObj['dateOfBirth']
        ? fieldValueObj['dateOfBirthWeightage']
        : 0) +
      (fieldValueObj['alias'] ? fieldValueObj['aliasWeightage'] : 0) +
      (fieldValueObj['countryofBirth']
        ? fieldValueObj['countryOfBirthWeightage']
        : 0) +
      (fieldValueObj['addressLine1'] ||
      fieldValueObj['addressLine2'] ||
      fieldValueObj['country'] ||
      fieldValueObj['city'] ||
      fieldValueObj['postCode']
        ? fieldValueObj['addressWeightage']
        : 0);
    let residentialAddressValue = '';
    if (residentialAddress) {
      residentialAddress.forEach((key) => {
        if (fieldValueObj[`${key}`]) {
          residentialAddressValue = residentialAddressValue
            ? `${residentialAddressValue}` + ' ' + fieldValueObj[`${key}`]
            : fieldValueObj[`${key}`];
        }
      });
    }
    let formatDate = fieldValueObj['dateOfBirth']
      ? moment(fieldValueObj['dateOfBirth']).format('YYYY-MM-DD')
      : '1800-01-01';
    let body = {
      explain: true,
      from: 0,
      size: 10,
      sort: '_score',
      query: {
        bool: { should: [{ match: { WATCHLIST_NAME: fieldValueObj['name'] } }] }
      },
      rescore: [
        {
          window_size: 60,
          query: {
            rescore_query: {
              function_score: {
                doc_score: {
                  fields: {
                    WATCHLIST_COUNTRY_OF_BIRTH: {
                      query_value: get(fieldValueObj, 'countryofBirth')
                        ? get(fieldValueObj, 'countryofBirth')
                        : 'test_value',
                      weight: fieldValueObj['countryofBirth']
                        ? fieldValueObj['countryOfBirthWeightage'] /
                          rescoreQueryMultiplier
                        : 0.0001
                    },
                    WATCHLIST_NATIONALITY: {
                      query_value: get(fieldValueObj, 'nationality')
                        ? get(fieldValueObj, 'nationality')
                        : 'test_value',
                      weight: fieldValueObj['nationality']
                        ? fieldValueObj['nationalityWeightage'] /
                          rescoreQueryMultiplier
                        : 0.0001
                    }
                  }
                }
              }
            },
            query_weight: 0,
            rescore_query_weight:
              ((fieldValueObj['countryofBirth']
                ? fieldValueObj['countryOfBirthWeightage']
                : 0.0001) +
                (fieldValueObj['nationality']
                  ? fieldValueObj['nationalityWeightage']
                  : 0.0001)) /
              rescoreQueryMultiplier
          }
        },
        {
          window_size: 60,
          query: {
            rescore_query: {
              nested: {
                path: 'WATCHLIST_ALIAS',
                score_mode: 'max',
                query: {
                  function_score: {
                    name_score: {
                      field: 'WATCHLIST_ALIAS.NAME',
                      query_name: get(fieldValueObj, 'alias')
                        ? get(fieldValueObj, 'alias')
                        : 'test_value',
                      universe: 'parameterUniverse1157064443'
                    }
                  }
                }
              }
            },
            query_weight: 1,
            rescore_query_weight:
              (fieldValueObj['alias']
                ? fieldValueObj['aliasWeightage']
                : 0.0001) / rescoreQueryMultiplier
          }
        },
        {
          window_size: 60,
          query: {
            rescore_query: {
              function_score: {
                name_score: {
                  field: 'WATCHLIST_NAME',
                  query_name: fieldValueObj['name'],
                  universe: 'parameterUniverse1157064443'
                }
              }
            },
            query_weight: 1,
            rescore_query_weight:
              fieldValueObj['nameWeightage'] / rescoreQueryMultiplier
          }
        },
        {
          window_size: 60,
          query: {
            rescore_query: {
              function_score: {
                name_score: {
                  field: 'WATCHPERSON_RESIDENTIAL_ADDRESS',
                  query_name: residentialAddressValue
                    ? residentialAddressValue
                    : 'test_value',
                  universe: 'parameterUniverse1157064443'
                }
              }
            },
            query_weight: 1,
            rescore_query_weight:
              (residentialAddressValue
                ? fieldValueObj['addressWeightage']
                : 0.0001) / rescoreQueryMultiplier
          }
        },
        {
          window_size: 60,
          query: {
            rescore_query: {
              function_score: {
                date_score: {
                  field: 'DATE_OF_BIRTH',
                  query_date: formatDate,
                  universe: 'parameterUniverse1157064443'
                }
              }
            },
            query_weight: 1,
            rescore_query_weight:
              (fieldValueObj['dateOfBirth']
                ? fieldValueObj['dateOfBirthWeightage']
                : 0.0001) / rescoreQueryMultiplier
          }
        }
      ]
    };
    setProfileMatchingArray(profileArray);
    setSearchFormPayload(fieldValueObj);
    apiActions.getAMLSCommonSandboxUI(body);
  };

  const validatingRegex = (pattern, value) => {
    let newPattern = pattern
      ? pattern
      : '/^([a-zA-Z0-9]){0,1}([a-zA-Z0-9\\s_\\-\\.\\,]){0,499}$/'; // Regex for TextArea
    let regex = new RegExp(trim(newPattern, '/'));
    return regex.test(value.trimEnd());
  };

  const setFieldValue = (e) => {
    const { id, name, value, pattern, min, max, required } = e.target;
    setFieldValueObj({
      ...fieldValueObj,
      [name]: value
    });
    if (value === '' && required) {
      setErrors({
        ...errors,
        [name]: `${id} is mandatory`
      });
    } else if (/^[\s_\-]$/.test(value.charAt(0))) {
      // for space at the starting of string
      setErrors({
        ...errors,
        [name]: `${id} cannot start with space`
      });
    } else if (
      /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(value.charAt(0))
    ) {
      // for special characters at the starting of string
      setErrors({
        ...errors,
        [name]: `${id} cannot start with special characters`
      });
    } else if (!validatingRegex(pattern, value) && value) {
      // for Regex validation
      if (name == 'nationality') {
        setErrors({
          ...errors,
          [name]: `${id} Must be ${min}-${max} characters (a-z A-Z)`
        });
      } else if (name == 'postCode') {
        setErrors({
          ...errors,
          [name]: `${id} Must be ${min}-${max} characters (0-9)`
        });
      } else {
        setErrors({
          ...errors,
          [name]: `${id} Must be ${min}-${max} characters (a-z A-Z 0-9 _ - space)`
        });
      }
    } else {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };

  const setFieldWeightageValue = (name, value) => {
    if (value < 0 || value > 100) return;
    let totalWeightage = value;
    Object.keys(fieldValueObjWithDefaultValues).map((obj) => {
      if (name !== obj) {
        totalWeightage += fieldValueObj[obj];
      }
    });
    if (totalWeightage != 100) {
      setErrors({
        ...errors,
        weightageError: 'Total weightage % should be 100. Please check.'
      });
    } else {
      setErrors({
        ...errors,
        weightageError: ''
      });
    }
    let stringValue = value?.toString();
    let finalValue =
      stringValue?.indexOf('.') >= 0
        ? stringValue?.substr(0, stringValue?.indexOf('.')) +
          stringValue?.substr(stringValue?.indexOf('.'), 3)
        : value;
    setFieldValueObj({
      ...fieldValueObj,
      [name]: Number(finalValue)
    });
  };

  const onCalendarChange = (momentDates, dates, key) => {
    setFieldValueObj({
      ...fieldValueObj,
      [key]: momentDates
    });
  };

  const onBlur = (e) => {
    const { id, name, value, required } = e.target;
    if (value === '' && required) {
      setErrors({
        ...errors,
        [name]: `${id} is mandatory`
      });
    }
  };

  const disableSearchBtn = () => {
    let disable = false;
    if (
      !fieldValueObj['name'] ||
      Object.values(errors)?.filter((el) => el)?.length
    ) {
      disable = true;
    }
    return disable;
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <div className={style.sandbox_wrapper}>
            <div className={style.head}>
              <div>
                <BreadCrumb crumbs={[{ label: 'Search By Name' }]} />
                <div className={style.head_content}>
                  <h4>Search By Name</h4>
                </div>
              </div>
            </div>
            <div className={style.body_content}>
              <div className={style.container_wrapper}>
                <div className={style.fieldsContainer}>
                  <div className={style.inputField}>
                    <label className={style.label}>
                      Search Name
                      <span className={style.isRequired}>*</span>
                    </label>
                    <p className={style.floatingLabel}>
                      Person/Organization Name
                    </p>
                    <Space>
                      <Search
                        id="Name"
                        name="name"
                        placeholder="Please input"
                        className={style.searchField}
                        allowClear={false}
                        onSearch={() => {
                          if (fieldValueObj['name'] && !disableSearchBtn()) {
                            onSearch();
                          }
                        }}
                        onChange={setFieldValue}
                        value={fieldValueObj['name']}
                        style={{ width: 240 }}
                        min={1}
                        max={500}
                        onBlur={onBlur}
                        required={true}
                        // pattern={/^(?=.*\d)(?=.*[a-zA-Z]){1,500}$/}
                        // pattern={/^[a-zA-Z0-9]([a-zA-Z0-9_\\s\\-]){2,99}$/}
                        // /^[ A-Za-z0-9_@./#&+-]*$/
                        pattern={
                          /^[a-zA-Z0-9]([a-zA-Z0-9\s_@./!@#$%^&*()+~`=-]){0,500}$/
                        }
                      />
                      <Button
                        className={style.addMoreBtn}
                        onClick={() => setShowAdditionalFields(true)}
                        disabled={
                          !fieldValueObj['name'] ||
                          Object.values(errors)?.filter((el) => el)?.length
                        }>
                        Add more details
                      </Button>
                    </Space>
                    {errors['name'] !== '' && (
                      <p className={style.errorMessage} id="error_name">
                        {errors['name']}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              {showAdditionalFields && (
                <>
                  <div className={style.container_wrapper}>
                    <div className={style.fieldsContainer}>
                      <div className={style.inputField}>
                        <label className={style.label}>
                          Search Nationality
                        </label>
                        <p className={style.floatingLabel}>Nationality</p>
                        <Space>
                          <Input
                            id="Nationality"
                            name="nationality"
                            placeholder="Please input"
                            style={{ width: 240 }}
                            onChange={setFieldValue}
                            value={fieldValueObj['nationality']}
                            min={1}
                            max={500}
                            onBlur={onBlur}
                            // pattern={/^[a-zA-Z\s_@./!@#$%^&*()+~`=-]{1,500}$/}
                            pattern={
                              /^[a-zA-Z]([a-zA-Z0-9\s_@./!@#$%^&*()+~`=-]){0,500}$/
                            }
                          />
                        </Space>
                        {errors['nationality'] !== '' && (
                          <p
                            className={style.errorMessage}
                            id="error_nationality">
                            {errors['nationality']}
                          </p>
                        )}
                      </div>
                      <div className={style.inputField}>
                        <label className={style.label}>Search Alias</label>
                        <p className={style.floatingLabel}>Alias</p>
                        <Space>
                          <Input
                            id="Alias"
                            name="alias"
                            placeholder="Please input"
                            style={{ width: 240 }}
                            min={1}
                            max={500}
                            onChange={setFieldValue}
                            value={fieldValueObj['alias']}
                            onBlur={onBlur}
                            pattern={
                              /^[a-zA-Z0-9]([a-zA-Z0-9\s_@./!@#$%^&*()+~`=-]){0,500}$/
                            }
                          />
                        </Space>
                        {errors['alias'] !== '' && (
                          <p className={style.errorMessage} id="error_alias">
                            {errors['alias']}
                          </p>
                        )}
                      </div>
                      <div className={style.inputField}>
                        <label className={style.label}>
                          Search Country of Birth/Incorporation
                        </label>
                        <p className={style.floatingLabel}>Country of Birth</p>
                        <Space>
                          <Input
                            id="Country Of Birth"
                            name="countryofBirth"
                            placeholder="Please input"
                            style={{ width: 240 }}
                            onChange={setFieldValue}
                            value={fieldValueObj['countryofBirth']}
                            onBlur={onBlur}
                            pattern={
                              /^[a-zA-Z0-9]([a-zA-Z0-9\s_@./!@#$%^&*()+~`=-]){0,500}$/
                            }
                          />
                        </Space>
                        {errors['countryofBirth'] !== '' && (
                          <p
                            className={style.errorMessage}
                            id="error_countryofBirth">
                            {errors['countryofBirth']}
                          </p>
                        )}
                      </div>
                      <div className={style.inputField}>
                        <label className={style.label}>
                          Search Date Of Birth
                        </label>
                        <p className={style.floatingLabel}>Select Date</p>
                        <Space>
                          <DatePicker
                            id="Date Of Birth"
                            name="dateOfBirth"
                            placeholder="Please input"
                            format={dateFormatList}
                            style={{ width: 240 }}
                            onChange={(m, d) =>
                              onCalendarChange(m, d, 'dateOfBirth')
                            }
                            value={fieldValueObj['dateOfBirth']}
                            disabledDate={disabledDate}
                          />
                        </Space>
                      </div>
                    </div>
                  </div>
                  <div className={style.container_wrapper}>
                    <div
                      className={style.fieldsContainer}
                      style={{ width: 500 }}>
                      <div className={style.inputField}>
                        <label className={style.label}>Search Address</label>
                        <Space size="middle">
                          <div>
                            <p className={style.floatingLabel}>
                              Address Line 1
                            </p>
                            <Input
                              id="Address Line 1"
                              name="addressLine1"
                              placeholder="Please input"
                              style={{ width: 240 }}
                              onChange={setFieldValue}
                              value={fieldValueObj['addressLine1']}
                              onBlur={onBlur}
                              pattern={
                                /^[a-zA-Z0-9]([a-zA-Z0-9\s_@./!@#$%^&*()+~`=-]){0,500}$/
                              }
                            />
                            {errors['addressLine1'] !== '' && (
                              <p
                                className={style.errorMessage}
                                id="error_addressLine1">
                                {errors['addressLine1']}
                              </p>
                            )}
                          </div>
                          <div>
                            <p className={style.floatingLabel}>
                              Address Line 2
                            </p>
                            <Input
                              id="Address Line 2"
                              name="addressLine2"
                              placeholder="Please input"
                              style={{ width: 240 }}
                              onChange={setFieldValue}
                              value={fieldValueObj['addressLine2']}
                              onBlur={onBlur}
                              pattern={
                                /^[a-zA-Z0-9]([a-zA-Z0-9\s_@./!@#$%^&*()+~`=-]){0,500}$/
                              }
                            />
                            {errors['addressLine2'] !== '' && (
                              <p
                                className={style.errorMessage}
                                id="error_addressLine2">
                                {errors['addressLine2']}
                              </p>
                            )}
                          </div>
                          <div>
                            <p className={style.floatingLabelSmall}>
                              Zip / Postcode
                            </p>
                            <Space size="middle">
                              <Input
                                id="ZIP / Post Code"
                                name="postCode"
                                placeholder="Please input"
                                style={{ width: 100 }}
                                onChange={setFieldValue}
                                min={1}
                                max={50}
                                value={fieldValueObj['postCode']}
                                onBlur={onBlur}
                                pattern={/^([0-9\s_@./!@#$%^&*()+~`=-]){1,50}$/}
                              />
                            </Space>
                            {errors['postCode'] !== '' && (
                              <p
                                className={style.errorMessage}
                                id="error_postCode">
                                {errors['postCode']}
                              </p>
                            )}
                          </div>
                        </Space>
                      </div>
                      <div className={style.inputField}>
                        <Space size="middle">
                          <div style={{ display: 'block' }}>
                            <p className={style.floatingLabel}>Country</p>
                            <Input
                              id="Country"
                              name="country"
                              placeholder="Please input"
                              style={{ width: 240 }}
                              onChange={setFieldValue}
                              value={fieldValueObj['country']}
                              onBlur={onBlur}
                              pattern={
                                /^[a-zA-Z0-9]([a-zA-Z0-9\s_@./!@#$%^&*()+~`=-]){0,500}$/
                              }
                            />
                            {errors['country'] !== '' && (
                              <p
                                className={style.errorMessage}
                                id="error_country">
                                {errors['country']}
                              </p>
                            )}
                          </div>
                          <div style={{ display: 'block' }}>
                            <p className={style.floatingLabel}>City</p>
                            <Input
                              id="City"
                              name="city"
                              placeholder="Please input"
                              style={{ width: 240 }}
                              onChange={setFieldValue}
                              value={fieldValueObj['city']}
                              onBlur={onBlur}
                              pattern={
                                /^[a-zA-Z0-9]([a-zA-Z0-9\s_@./!@#$%^&*()+~`=-]){0,500}$/
                              }
                            />
                            {errors['city'] !== '' && (
                              <p className={style.errorMessage} id="error_city">
                                {errors['city']}
                              </p>
                            )}
                          </div>
                        </Space>
                      </div>
                    </div>
                  </div>
                  <div className={style.container_wrapper}>
                    <div
                      className={style.fieldsContainer}
                      style={{ width: 300 }}>
                      <div className={style.inputField} style={{ height: 14 }}>
                        <label className={style.label}>Weightage %</label>
                        <Space size="middle">
                          <div>
                            <p className={style.floatingLabelSmall}>Name</p>
                            <InputNumber
                              name="nameWeightage"
                              placeholder="Please input"
                              style={{ width: 100 }}
                              onChange={(value) => {
                                setFieldWeightageValue('nameWeightage', value);
                              }}
                              defaultValue={fieldValueObj['nameWeightage']}
                              value={fieldValueObj['nameWeightage']}
                            />
                          </div>
                          <div>
                            <p className={style.floatingLabelSmall}>
                              Nationality
                            </p>
                            <InputNumber
                              name="nationalityWeightage"
                              placeholder="Please input"
                              style={{ width: 100 }}
                              onChange={(value) => {
                                setFieldWeightageValue(
                                  'nationalityWeightage',
                                  value
                                );
                              }}
                              defaultValue={5}
                              value={fieldValueObj['nationalityWeightage']}
                            />
                          </div>
                          <div>
                            <p className={style.floatingLabelSmall}>
                              Date Of Birth
                            </p>
                            <InputNumber
                              name="dateOfBirthWeightage"
                              placeholder="Please input"
                              style={{ width: 100 }}
                              onChange={(value) => {
                                setFieldWeightageValue(
                                  'dateOfBirthWeightage',
                                  value
                                );
                              }}
                              defaultValue={5}
                              value={fieldValueObj['dateOfBirthWeightage']}
                            />
                          </div>
                          <div>
                            <p className={style.floatingLabelSmall}>Alias</p>
                            <InputNumber
                              name="aliasWeightage"
                              placeholder="Please input"
                              style={{ width: 100 }}
                              onChange={(value) => {
                                setFieldWeightageValue('aliasWeightage', value);
                              }}
                              defaultValue={15}
                              value={fieldValueObj['aliasWeightage']}
                            />
                          </div>
                          <div>
                            <p className={style.floatingLabelSmall}>
                              Country Of Birth
                            </p>
                            <InputNumber
                              name="countryOfBirthWeightage"
                              placeholder="Please input"
                              style={{ width: 100 }}
                              onChange={(value) => {
                                setFieldWeightageValue(
                                  'countryOfBirthWeightage',
                                  value
                                );
                              }}
                              defaultValue={5}
                              value={fieldValueObj['countryOfBirthWeightage']}
                            />
                          </div>
                          <div>
                            <p className={style.floatingLabelSmall}>Address</p>
                            <InputNumber
                              name="addressWeightage"
                              placeholder="Please input"
                              style={{ width: 100 }}
                              onChange={(value) => {
                                setFieldWeightageValue(
                                  'addressWeightage',
                                  value
                                );
                              }}
                              defaultValue={10}
                              value={fieldValueObj['addressWeightage']}
                            />
                          </div>
                        </Space>
                        {errors['weightageError'] !== '' && (
                          <p
                            className={style.errorMessage}
                            id="error_weightageError">
                            {errors['weightageError']}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className={style.buttonGroup}>
                      <Space>
                        <Button
                          id="clearBtn"
                          className={style.clearBtn}
                          onClick={() => {
                            setFieldValueObj(fieldValueObjWithDefaultValues);
                            apiActions.resetAMLSCommonSandboxUIResults();
                            setShowAdditionalFields(false);
                            setErrors({});
                          }}>
                          Clear
                        </Button>
                        <Button
                          id="searchBtn"
                          className={style.btn_primary}
                          onClick={() => onSearch()}
                          disabled={disableSearchBtn()}>
                          Search
                        </Button>
                      </Space>
                    </div>
                  </div>
                </>
              )}
              {searchResults?.isLoading && isAppLoading ? (
                <div className={style.loaderContainer}>
                  <Spin />
                </div>
              ) : (
                <>
                  {get(searchResults, 'data.hits.hits', null) && (
                    <ResultsComponent
                      searchResults={searchResults}
                      formData={searchFormPayload}
                      profileMatchingArray={profileMatchingArray}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

Sandbox.propTypes = {};

export default Sandbox;
